import { Box, Typography } from '@mui/material';
import { NotificationsOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAlertCount, markAllAlertsRead } from '@/features/alerts';

export function HomeAlertsSummary() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { count, refetch } = useAlertCount();

  const handleClick = async () => {
    if (count > 0) {
      markAllAlertsRead().catch(() => undefined);
      await refetch();
    }
    navigate('/alerts');
  };

  return (
    <Box
      data-testid="home-alerts-summary"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') void handleClick();
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        px: 2,
        py: 1.2,
        borderRadius: 1,
        bgcolor: 'background.paper',
        boxShadow: 1,
        cursor: 'pointer',
        '&:hover': { boxShadow: 3 },
        '&:active': { opacity: 0.85 },
      }}
    >
      {/* Yellow bell icon */}
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: 1,
          bgcolor: 'secondary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <NotificationsOutlined sx={{ color: 'primary.main', fontSize: 24 }} />
      </Box>

      {/* Label */}
      <Typography variant="body1" sx={{ flex: 1, fontWeight: 500, color: 'text.primary' }}>
        {t('home.alerts.summary', { count })}
      </Typography>

      {/* Count badge */}
      <Box
        data-testid="home-alerts-summary-count"
        sx={{
          minWidth: 28,
          height: 28,
          borderRadius: '50%',
          bgcolor: 'secondary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 0.5,
        }}
      >
        <Typography
          variant="caption"
          sx={{ fontWeight: 700, color: 'primary.main', lineHeight: 1 }}
        >
          {count > 99 ? '99+' : count}
        </Typography>
      </Box>
    </Box>
  );
}
